import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl, baseimgUrl } from "../Univ";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Swal from "sweetalert2";

function MyProducts() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchMyProducts();
  }, []);

  const fetchMyProducts = async () => {
    try {
      const res = await axios.get(baseUrl + "seller-products/");
      setProducts(res.data);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to fetch products", "error");
    }
  };

  const deleteProduct = async (id) => {
    const result = await Swal.fire({
      title: "Delete Product?",
      showCancelButton: true,
      icon: "warning",
    });

    if (result.isConfirmed) {
      try {
        await axios.post(baseUrl + "delete-product/", { id });
        Swal.fire("Deleted!", "Product has been deleted", "success");
        fetchMyProducts();
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Failed to delete product", "error");
      }
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">My Products</h3>

      <div className="row">
        {products.map((p) => (
          <div key={p.id} className="col-md-6 mb-4">
            <div className="card shadow-sm h-100">
              {/* Image Carousel */}
              <Carousel
                showThumbs={true}
                showStatus={false}
                infiniteLoop
                useKeyboardArrows
                dynamicHeight={true}
              >
                {p.images && p.images.length > 0 ? (
                  p.images.map((img, i) => (
                    <div key={i}>
                      <img
                        src={`${baseimgUrl}${img.image}`}
                        alt={p.name}
                        style={{ objectFit: "contain", maxHeight: "200px" }}
                      />
                    </div>
                  ))
                ) : (
                  <div>
                    <img
                      src="https://via.placeholder.com/200x150?text=No+Image"
                      alt="No Image"
                    />
                  </div>
                )}
              </Carousel>

              <div className="card-body">
                <h5 className="card-title">{p.name}</h5>
                <p className="mb-1">
                  <strong>Category:</strong> {p.category_name || "N/A"}
                </p>
                <p className="mb-1">
                  <strong>Price:</strong> ₹{p.price}{" "}
                  {p.discount_price && (
                    <span className="text-muted ms-2">
                      (Discount: ₹{p.discount_price})
                    </span>
                  )}
                </p>
                <p className="mb-1">
                  <strong>Stock:</strong> {p.stock}
                </p>
                <p className="mb-1">
                  <strong>Status:</strong>{" "}
                  {p.is_active ? "Active" : "Inactive"}
                </p>
                <p className="mb-2">
                  <strong>Description:</strong> {p.description || "N/A"}
                </p>

                <div className="d-flex justify-content-between">
                  <button
                    onClick={() => deleteProduct(p.id)}
                    className="btn btn-danger btn-sm"
                  >
                    Delete
                  </button>

                  <a
                    href={`/seller/edit/${p.id}`}
                    className="btn btn-primary btn-sm"
                  >
                    Edit
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}

        {products.length === 0 && (
          <p className="text-center mt-4">No products found.</p>
        )}
      </div>
    </div>
  );
}

export default MyProducts;
